import { Select } from "antd";
import React, { memo, useCallback } from "react";

const { Option } = Select;

const INIT_CONTRACT_STATUS = [
  {
    id: -1,
    code: "ALL",
    name: "Tất cả",
    status: null,
    driver_is_transferred_another: null,
    vehicle_is_transferred_another: null,
  },
  {
    id: 1,
    code: "WAITING_ASSIGN_CAR",
    name: "Đang chờ điều xe",
    color: "#fbe350",
    status: 1,
    driver_is_transferred_another: false,
    vehicle_is_transferred_another: false,
  },
  {
    id: 2,
    code: "ASSIGNED_CAR",
    name: "Đã điều xe",
    color: "#e68927",
    status: 2,
    driver_is_transferred_another: false,
    vehicle_is_transferred_another: false,
  },
  {
    id: 3,
    code: "IN_PROGRESS",
    name: "Đang diễn ra",
    color: "#45acf9",
    status: 3,
    driver_is_transferred_another: false,
    vehicle_is_transferred_another: false,
  },
  {
    id: 4,
    code: "FINISHED",
    name: "Đã hoàn thành",
    color: "#139123",
    status: 4,
    driver_is_transferred_another: false,
    vehicle_is_transferred_another: false,
  },
  {
    id: 5,
    code: "CANCELED",
    name: "Đã huỷ",
    color: "#d11338",
    status: 5,
    driver_is_transferred_another: false,
    vehicle_is_transferred_another: false,
  },
  {
    id: 6,
    code: "CAR_LOAN",
    name: "Đang cho mượn xe",
    color: "#b330dc",
    status: null,
    driver_is_transferred_another: false,
    vehicle_is_transferred_another: true,
  },
  {
    id: 7,
    code: "DRIVER_LOAN",
    name: "Đang cho mượn tài",
    color: "#32dc8e",
    status: null,
    driver_is_transferred_another: true,
    vehicle_is_transferred_another: false,
  },
  {
    id: 8,
    code: "CAR_DRIVER_LOAN",
    name: "Đang cho mượn xe và tài",
    color: "#E60EBB",
    status: null,
    driver_is_transferred_another: true,
    vehicle_is_transferred_another: true,
  },
];

const TrangThaiHopDong = ({ setFieldsValue }) => {
  const onChange = useCallback((values) => {
    const findItem = INIT_CONTRACT_STATUS.find((i) => i.code === values.value);

    !!findItem &&
      !!setFieldsValue &&
      setFieldsValue({
        status: findItem.status,
        driver_is_transferred_another: findItem.driver_is_transferred_another,
        vehicle_is_transferred_another: findItem.vehicle_is_transferred_another,
      });
  }, []);

  return (
    <Select
      showArrow
      placeholder="Trạng thái HĐ"
      labelInValue
      filterOption={false}
      onChange={onChange}
    >
      {INIT_CONTRACT_STATUS.map((item, index) => (
        <Option key={index} value={item.code}>
          {item.name}
        </Option>
      ))}
    </Select>
  );
};

export default memo(TrangThaiHopDong);
